/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from 'sarsaparilla';

const defaultProps = {
    displayError: false,
};

const propTypes = {
    toggle: PropTypes.func.isRequired,
    displayError: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.element),
};

function ValidationError({ displayError, children, toggle }) {
    if (!displayError) {
        return null;
    }
    return (
        <div className="rec-notification-error rec-error-page-topper">
            <span className="rec-notification-icon">
                <Icon iconName="error" />
            </span>
            <div className="rec-notification-body">
                <div className="rec-notification-title">Validation Errors:</div>
                {children}
            </div>
            <button
                type="button"
                className="rec-notification-close"
                onClick={toggle}
                aria-label="Dismiss validation errors"
            >
                <Icon iconName="close" />
            </button>
        </div>
    );
}

ValidationError.propTypes = propTypes;
ValidationError.defaultProps = defaultProps;

export default ValidationError;
